import React, { useEffect, useRef } from "react";
import style from "./index.module.scss";
import { useUpdateEffect } from "react-use";
import { Modal } from "antd";
import GetScript from "../GetScript/index";

declare global {
    interface Window {
        polyvPlayer: any;
    }
}

interface VideoViewerProps {
    vid: string;
}

export default function VideoViewer({ vid }: VideoViewerProps) {
    const playerRef = useRef<any>(null);
    const wrapperRef = useRef<HTMLDivElement>(null);

    useUpdateEffect(() => {
        if (!playerRef.current) return;
        playerRef.current.changeVid({ vid, autoplay: false });
    }, [vid]);

    useEffect(() => {
        return () => {
            if (!playerRef.current) return;
            playerRef.current.destroy();
        };
    }, []);

    function onLoad() {
        if (!wrapperRef.current) return;
        playerRef.current = window.polyvPlayer({
            wrap: wrapperRef.current,
            height: "100%",
            forceH5: true,
            vid: vid,
            autoplay: false
        });
    }

    function onError() {
        Modal.error({ content: "播放器加载失败!", getContainer });
    }

    function getContainer(): any {
        return document.querySelector(".PopupContainer");
    }

    return (
        <GetScript
            src="https://player.polyv.net/resp/vod-player/latest/player.js"
            onLoad={onLoad}
            onError={onError}>
            <div ref={wrapperRef} className={style.video} />
        </GetScript>
    );
}
